export default function init() {
    document.addEventListener('DOMContentLoaded', () => {
        const textToSpeech = document.getElementById('text-to-speech');
        const metaIcons = document.querySelector('.meta-icons');
        const authorDate = document.querySelector('.author-date');

        const moveTextToSpeech = () => {
            if (window.innerWidth < 992) {
                if (!metaIcons.contains(textToSpeech)) {
                    metaIcons.insertBefore(textToSpeech, metaIcons.firstChild);
                }
            } else {
                if (!authorDate.contains(textToSpeech)) {
                    authorDate.appendChild(textToSpeech);
                }
            }
        };

        moveTextToSpeech();
        window.addEventListener('resize', moveTextToSpeech);
    });
}
